function extendValidationSettings(settings) {
    var extended = $.extend({}, {
        highlight: function (element, label) {
            var group = $(element).closest('.form-group');
            group.addClass('error').removeClass('noError');
            $(element).addClass('error').removeClass('noError');
            group.find('[id^=s2id]').addClass('error');
        },
        unhighlight: function (element, label) {
            var group = $(element).closest('.form-group');
            group.addClass('noError').removeClass('error');
            $(element).addClass('noError').removeClass('error');
            group.find('[id^=s2id]').addClass('noError').removeClass('error');
        },
        success: function (element, label) {
            var group = $(element).closest('.form-group');
            if (group.find('.error').length === 0) {
                group.removeClass('error');
            }
        },
        errorContainer: '#errorMessageBox',
        errorLabelContainer: '#errorList',
        errorElement: "li",
        onkeyup: false,
        ignore: ''
    }, settings);

    return extended;
}

//Regex

//http://regexlib.com/DisplayPatterns.aspx?cattabindex=4&categoryid=5&p=6&AspxAutoDetectCookieSupport=1
var TIME_REGEX = /^(?:(?:0?[0-9]|1[0-2]):[0-5][0-9]\s?(?:(?:[Aa]|[Pp])[Mm])?|(?:1[3-9]|2[0-3]):[0-5][0-9])$/;

//http://regexlib.com/REDetails.aspx?regexp_id=416
var DATE_REGEX = /^(((0[13578]|10|12)([-./])(0[1-9]|[12][0-9]|3[01])([-./])(\d{4}))|((0[469]|11)([-./])([0][1-9]|[12][0-9]|30)([-./])(\d{4}))|((02)([-./])(0[1-9]|1[0-9]|2[0-8])([-./])(\d{4}))|((02)(\.|-|\/)(29)([-./])([02468][048]00))|((02)([-./])(29)([-./])([13579][26]00))|((02)([-./])(29)([-./])([0-9][0-9][0][48]))|((02)([-./])(29)([-./])([0-9][0-9][2468][048]))|((02)([-./])(29)([-./])([0-9][0-9][13579][26])))$/;

//http://regexlib.com/REDetails.aspx?regexp_id=2645
var UNSIGNED_SHORT_INT_REGEX = /^(0|(\+)?([1-9]{1}[0-9]{0,3})|([1-5]{1}[0-9]{1,4}|[6]{1}([0-4]{1}[0-9]{3}|[5]{1}([0-4]{1}[0-9]{2}|[5]{1}([0-2]{1}[0-9]{1}|[3]{1}[0-5]{1})))))$/;

//http://regexlib.com/REDetails.aspx?regexp_id=53
var HOURS_REGEX = /^\d*\.?\d*$/;

jQuery.validator.addMethod("greaterThan",
    function (value, element, params) {
        if (this.optional(element)) {
            return true;
        }

        if (!/Invalid|NaN/.test(new Date(value))) {
            return new Date(value) > new Date($(params).val());
        }

        return isNaN(value) && isNaN($(params).val())
            || (Number(value) > Number($(params).val()));
    }, 'Must be greater than {0}.');

jQuery.validator.addMethod("greaterThanOrEqual",
    function (value, element, params) {
        if (this.optional(element)) {
            return true;
        }

        if (!/Invalid|NaN/.test(new Date(value))) {
            return new Date(value) >= new Date($(params).val());
        }

        return isNaN(value) && isNaN($(params).val())
            || (Number(value) >= Number($(params).val()));
    }, 'Must be greater than or equal to {0}.');

jQuery.validator.addMethod("lessThanOrEqual",
    function (value, element, params) {
        if (this.optional(element)) {
            return true;
        }

        if (!/Invalid|NaN/.test(new Date(value))) {
            return new Date(value) <= new Date($(params).val());
        }

        return isNaN(value) && isNaN($(params).val()) || (Number(value) <= Number($(params).val()));
    }, 'Must be less than or equal to {0}.');

jQuery.validator.addMethod(
    "validTime",
    function (value, element) {
        return value.match(TIME_REGEX);
    }, 'Time is not valid.'
);

jQuery.validator.addMethod(
    "validDate",
    function (value, element) {
        return value.match(DATE_REGEX);
    }, 'Date is not valid.'
);

jQuery.validator.addMethod(
    "validUnsignedShortInteger",
    function (value, element) {
        return value.match(UNSIGNED_SHORT_INT_REGEX);
    }, 'Number is not valid.'
);

jQuery.validator.addMethod(
    "validHours",
    function (value, element) {
        return value.match(HOURS_REGEX);
    }, 'Hour is not valid.'
);

jQuery.validator.addMethod("timeGreaterThan",
    function (value, element, params) {
        var endTime = moment("1/1/2000 " + value);

        var startTime = moment("1/1/2000 " + $(params).val());

        return endTime.isAfter(startTime);
    }, 'Must be greater than {0}.');

jQuery.validator.addMethod('trimEqualTo', function (value, element, param) {
    var target = $(param);
    if (this.settings.onfocusout) {
        target.off(".validate-equalTo").on("blur.validate-equalTo", function () {
            $(element).valid();
        });
    }

    return $.trim(value) === target.val();
}, 'Please enter the same value again.');

/**
 * matches US phone number format
 *
 * where the area code may not start with 1 and the prefix may not start with 1
 * allows '-' or ' ' as a separator and allows parens around area code
 * some people may want to put a '1' in front of their number
 *
 * 1(212)-999-2345 or
 * 212 999 2344 or
 * 212-999-0983
 *
 * but not
 * 111-123-5434
 * and not
 * 212 123 4567
 */
$.validator.addMethod("phoneUS", function (phone_number, element) {
    phone_number = phone_number.replace(/\s+/g, "");
    return this.optional(element) || phone_number.length > 9 &&
        phone_number.match(/^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]([02-9]\d|1[02-9])-?\d{4}$/);
}, "Please specify a valid phone number");
